import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import CodeValue from '~/components/patterns/values/CodeValue';
import Ellipsis from '~/components/patterns/values/Ellipsis';
import SmallTable from '~/components/atoms/issues/components/detailsPlaceholders/SmallTable';



const messages = defineMessages({
	assetUrl: {
		id: 'ui.issues.platform.robotsTxt.assetsDisallowed.factors.assetUrl',
	},
});



type Props = {
	issue: {
		context: {
			assetsList: ReadonlyArray<{
				asset: string,
				userAgent: string,
			}>,
		},
	},
	tableWidth: number,
};

const DisallowedAssetsTable: React.FC<Props> = (props) => {
	const {
		issue,
		tableWidth,
	} = props;

	const firstColumnWidth = Math.floor(tableWidth * 0.25);

	return (
		<SmallTable
			columns={[
				{
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis>
									<CodeValue>
										{row.userAgent}
									</CodeValue>
								</Ellipsis>
							);
						},
						header: () => 'User-agent',
					},
					width: firstColumnWidth,
				},
				{
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis>
									{row.asset}
								</Ellipsis>
							);
						},
						header: () => (
							<FormattedMessage {...messages.assetUrl} />
						),
					},
					width: tableWidth - firstColumnWidth - 2,
				},
			]}
			rows={issue.context.assetsList}
			tableWidth={tableWidth}
		/>
	);
};



export default React.memo(DisallowedAssetsTable);
